/** Ported from haulsheet index.html ocrParseTrinity / Evans / Landstar / ocrParseRateCons. */
import { OCR_EQUIP, ocrBlankLoad, ocrNum, ocrTitle } from "./shared.js";
/** Fill pickup/delivery date strings from common rate-con layouts (do not invent). */
function fillRateConDates(raw, L) {
    let pu = raw.match(/Pick\s*Up\s*Date(?:\s*&\s*Time)?:\s*([\d/]+)/i) ||
        raw.match(/Pickup:\s*[\s\S]{0,220}?(\d{1,2}\/\d{1,2}\/\d{2,4})/i) ||
        raw.match(/Stop\s*#?\s*1\s*Origin[\s\S]{0,220}?Target\s*Window:\s*([\d/]+)/i) ||
        null;
    let del = raw.match(/Delivery\s*Date(?:\s*&\s*Time)?:\s*([\d/]+)/i) ||
        raw.match(/Delivery:\s*[\s\S]{0,220}?(\d{1,2}\/\d{1,2}\/\d{2,4})/i) ||
        raw.match(/Stop\s*#?\s*2\s*Destination[\s\S]{0,220}?Target\s*Window:\s*([\d/]+)/i) ||
        null;
    if (pu?.[1] && !L.pickup)
        L.pickup = pu[1];
    if (del?.[1] && !L.delivery)
        L.delivery = del[1];
}
/* ---- Trinity Logistics rate confirmation ---- */
export function ocrParseTrinity(text) {
    const raw = String(text || "");
    if (!/Trinity\s+Logistics/i.test(raw) && !/Rate\s+Confirmation\s*[-–—]\s*Trinity/i.test(raw))
        return [];
    const L = ocrBlankLoad();
    const ref = (raw.match(/Reference\s*#\s*(\d+)/i) || raw.match(/Shipment\s*#\s+(\d+)/i) || [])[1];
    L.ref = "Trinity" + (ref ? " #" + ref : "");
    const miles = raw.match(/Shipment\s*Miles\s*([\d,]+(?:\.\d+)?)/i);
    if (miles) {
        const mn = ocrNum(miles[1]);
        if (mn && parseFloat(mn) > 0)
            L.miles = String(Math.round(parseFloat(mn)));
    }
    function stopPlace(kind) {
        const re = new RegExp(kind + "[\\s\\S]{0,320}?([A-Za-z][A-Za-z .'\\-]{1,48}?),\\s*([A-Z]{2})\\s+(\\d{5})\\b", "i");
        const m = raw.match(re);
        if (!m)
            return "";
        let city = m[1].replace(/\s+/g, " ").trim();
        const streetish = /^(?:N|S|E|W|North|South|East|West|NE|NW|SE|SW|Dr|Rd|St|Ave|Blvd|Ln|Hwy|Road|Drive|Street|Avenue|Boulevard|Way|Trail|Pike|Ct|Court)$/i;
        const toks = city.split(/\s+/);
        let i = toks.length - 1;
        while (i > 0 && !streetish.test(toks[i - 1]))
            i--;
        if (i > 0 && streetish.test(toks[i - 1]))
            city = toks.slice(i).join(" ");
        else if (toks.length > 2)
            city = toks[toks.length - 1];
        return ocrTitle(city) + ", " + m[2].toUpperCase() + " " + m[3];
    }
    L.origin = stopPlace("Pickup");
    L.destination = stopPlace("Delivery");
    let lh = raw.match(/\bLINEHAUL\b(?:(?!FUEL\s*SURCHARGE)[\s\S]){0,80}?\$\s*([\d,]+(?:\.\d+)?)/i) || null;
    if (!lh)
        lh = raw.match(/\bLINEHAUL\b(?:(?!FUEL\s*SURCHARGE)[^\n]){0,80}?([\d,]+\.\d{2})/i);
    if (lh)
        L.linehaul = ocrNum(lh[1]);
    const fscMi = raw.match(/FUEL\s*SURCHARGE[\s\S]{0,80}?\$?\s*([\d.]+)\s*(?:\/\s*mi(?:le)?|per\s*(?:loaded\s*)?mi(?:le)?)/i);
    if (fscMi) {
        const fn = ocrNum(fscMi[1]);
        if (fn && parseFloat(fn) > 0 && parseFloat(fn) < 5)
            L.fsc = fn;
    }
    /* Dollar fuel totals without a per-mile rate are ignored (not invented into $/mi, not added to linehaul). */
    let extras = 0;
    const agree = (raw.match(/Carrier\s*Rate\s*Agreement[\s\S]{0,1200}?(?=Shipment\s*Notes|Terms\s*of\s*Agreement|$)/i) ||
        [])[0] || "";
    const itemRe = /^\s*\d+\s+(LINEHAUL|FUEL\s*SURCHARGE|[A-Z][A-Z \/&\-]{2,40})\b[\s\S]{0,140}?\$\s*([\d,]+(?:\.\d+)?)/gim;
    let im;
    while ((im = itemRe.exec(agree))) {
        const desc = String(im[1] || "").toUpperCase();
        const amt = parseFloat(ocrNum(im[2]) || "0");
        if (!(amt > 0))
            continue;
        if (/LINE\s*HAUL|LINEHAUL|FUEL|TOTAL/.test(desc))
            continue;
        extras += amt;
    }
    if (extras > 0)
        L.tarpFee = String(Math.round(extras * 100) / 100);
    const eq = raw.match(/Eq\s*Type\s+([A-Za-z0-9]+)/i);
    if (eq) {
        let code = String(eq[1]).replace(/^\d+/, "").toUpperCase();
        if (code === "FB")
            code = "F";
        L.equipment = OCR_EQUIP[code] || (code ? code + " (Trinity eq)" : eq[1]);
    }
    const wt = raw.match(/([\d,]+(?:\.\d+)?)\s*lbs\b/i);
    if (wt)
        L.weight = ocrNum(wt[1]);
    fillRateConDates(raw, L);
    if (!L.origin)
        L.unreadable.push("Origin could not be read");
    if (!L.destination)
        L.unreadable.push("Destination could not be read");
    if (!L.linehaul)
        L.unreadable.push("Linehaul could not be read");
    if (!(L.linehaul || L.origin || L.destination || L.miles))
        return [];
    return [L];
}
/* ---- Evans Transportation rate confirmation ---- */
export function ocrParseEvans(text) {
    const raw = String(text || "");
    if (!/Evans\s+Transportation/i.test(raw) && !/evanstrans\.com/i.test(raw))
        return [];
    const L = ocrBlankLoad();
    const ref = (raw.match(/Contract\s*#:\s*(\S+)/i) || [])[1];
    L.ref = "Evans" + (ref ? " " + ref : "");
    function cityAtEndOfLabeledLine(label) {
        const line = (raw.match(new RegExp(label + "\\s*:[^\\n]*", "i")) || [])[0] || "";
        let m = line.match(/([A-Za-z][A-Za-z .'\-]{1,40}?),\s*([A-Z]{2})\s+(\d{5})\s*$/);
        if (!m) {
            // Fallback: last City, ST ZIP on that line
            const all = [];
            let mm;
            const re = /([A-Za-z][A-Za-z .'\-]{1,40}?),\s*([A-Z]{2})\s+(\d{5})/g;
            while ((mm = re.exec(line)))
                all.push(mm);
            m = all.length ? all[all.length - 1] : null;
        }
        if (!m)
            return "";
        let city = m[1].replace(/\s+/g, " ").trim();
        // Drop leading street-ish tokens if city still has a street word before the real city
        const parts = city.split(/\s+/);
        if (parts.length > 1 &&
            /^(N|S|E|W|North|South|East|West|Dr|Rd|St|Ave|Blvd|Ln|Hwy|Sw|Nw|Se|Ne)$/i.test(parts[parts.length - 2])) {
            // keep as-is; better: take last 1–3 capitalized words that look like a city
        }
        // Prefer known simple city: take the trailing word(s) after the last street token
        const streetish = /^(?:N|S|E|W|North|South|East|West|Dr|Rd|St|Ave|Blvd|Ln|Hwy|Sw|Nw|Se|Ne|Gate|Suite|Ste|Road|Drive|Street|Avenue|Boulevard)$/i;
        const toks = city.split(/\s+/);
        let i = toks.length - 1;
        while (i > 0 && !streetish.test(toks[i - 1]))
            i--;
        if (i > 0 && streetish.test(toks[i - 1]))
            city = toks.slice(i).join(" ");
        else if (toks.length > 3)
            city = toks.slice(-2).join(" ");
        return ocrTitle(city) + ", " + m[2].toUpperCase() + " " + m[3];
    }
    L.origin = cityAtEndOfLabeledLine("Origin");
    L.destination = cityAtEndOfLabeledLine("Destination");
    if (!L.origin) {
        const puBlock = (raw.match(/Stop\s*1\s*\(\s*pickup\s*\)[\s\S]{0,450}?(?=Stop\s*2\s*\(|Freight\s*Terms|$)/i) ||
            [])[0] || "";
        const pum = puBlock.match(/([A-Za-z][A-Za-z .'\-]{1,40}?),\s*([A-Z]{2})\s+(\d{5})\b/);
        if (pum)
            L.origin =
                ocrTitle(pum[1].replace(/\s+/g, " ").trim()) + ", " + pum[2].toUpperCase() + " " + pum[3];
    }
    if (!L.destination) {
        const drBlock = (raw.match(/Stop\s*2\s*\(\s*(?:drop|delivery)\s*\)[\s\S]{0,450}?(?=Freight\s*Terms|Accessorial|Page\s+\d|$)/i) || [])[0] || "";
        const drm = drBlock.match(/([A-Za-z][A-Za-z .'\-]{1,40}?),\s*([A-Z]{2})\s+(\d{5})\b/);
        if (drm)
            L.destination =
                ocrTitle(drm[1].replace(/\s+/g, " ").trim()) + ", " + drm[2].toUpperCase() + " " + drm[3];
    }
    const ft = raw.match(/Freight\s*Terms:\s*\$?\s*([\d,]+(?:\.\d+)?)[^\n]*?\(([\d,]+(?:\.\d+)?)\s*lb\)[^\n]*?\(([\d,]+(?:\.\d+)?)\s*miles?\)/i);
    if (ft) {
        L.linehaul = ocrNum(ft[1]);
        L.weight = ocrNum(ft[2]);
        const em = ocrNum(ft[3]);
        if (em && parseFloat(em) > 0)
            L.miles = String(Math.round(parseFloat(em)));
    }
    if (!L.linehaul) {
        const lh = raw.match(/\bLinehaul\b\s+([\d,]+(?:\.\d+)?)/i) ||
            raw.match(/\bLinehaul\b(?:(?!Fuel\s*Surcharge)[\s\S]){0,120}?\$\s*([\d,]+(?:\.\d+)?)/i);
        if (lh)
            L.linehaul = ocrNum(lh[1]);
    }
    if (!L.miles) {
        const mi = raw.match(/\(([\d,]+(?:\.\d+)?)\s*miles?\)/i);
        if (mi) {
            const mn = ocrNum(mi[1]);
            if (mn && parseFloat(mn) > 0)
                L.miles = String(Math.round(parseFloat(mn)));
        }
    }
    const fscMi = raw.match(/Fuel\s*Surcharge[\s\S]{0,80}?\$?\s*([\d.]+)\s*(?:\/\s*mi(?:le)?|per\s*(?:loaded\s*)?mi(?:le)?)/i);
    if (fscMi) {
        const fn = ocrNum(fscMi[1]);
        if (fn && parseFloat(fn) > 0 && parseFloat(fn) < 5)
            L.fsc = fn;
    }
    let extras = 0;
    let rm;
    const rowRe = /^([A-Za-z][A-Za-z0-9 \/&\-]{2,40})\s+([\d,]+(?:\.\d+)?)\s+Flat\s*Rate\s+\$?\s*([\d,]+(?:\.\d+)?)/gim;
    while ((rm = rowRe.exec(raw))) {
        const d = String(rm[1] || "").toUpperCase();
        const amt = parseFloat(ocrNum(rm[3]) || "0");
        if (!(amt > 0))
            continue;
        if (/LINEHAUL|LINE\s*HAUL|FUEL|DISCOUNT|TOTAL/.test(d))
            continue;
        extras += amt;
    }
    if (extras > 0)
        L.tarpFee = String(Math.round(extras * 100) / 100);
    const eq = raw.match(/Equipment\s*Required:\s*([^\n]+)/i);
    if (eq)
        L.equipment = eq[1].replace(/\s+/g, " ").trim();
    fillRateConDates(raw, L);
    if (!L.origin)
        L.unreadable.push("Origin could not be read");
    if (!L.destination)
        L.unreadable.push("Destination could not be read");
    if (!L.linehaul)
        L.unreadable.push("Linehaul could not be read");
    if (!(L.linehaul || L.origin || L.destination || L.miles))
        return [];
    return [L];
}
/* ---- Landstar rate confirmation (agency LHT + older JXD forms) ---- */
export function ocrParseLandstar(text) {
    const raw = String(text || "");
    if (!/\bLANDSTAR\b/i.test(raw))
        return [];
    const L = ocrBlankLoad();
    const fb = (raw.match(/Freight\s*Bill\s*#:\s*(\d+)/i) ||
        raw.match(/Reference\s*#:\s*[A-Z]{2,4}\s*(\d+)/i) ||
        raw.match(/\bJXD\s+(\d+)/i) ||
        [])[1];
    L.ref = "Landstar" + (fb ? " #" + fb : "");
    const milesM = raw.match(/Total\s*Miles:\s*([\d,]+)/i);
    if (milesM) {
        const mn = ocrNum(milesM[1]);
        if (mn && parseFloat(mn) > 0)
            L.miles = mn;
    }
    // Miles may be absent on some Landstar forms — leave blank, do not invent
    let pay = raw.match(/Pay\s*Capacity[\s\S]{0,240}?\$\s*([\d,]+(?:\.\d+)?)/i) || null;
    if (!pay)
        pay = raw.match(/Agreed\s*Rate[\s\S]{0,240}?\$\s*([\d,]+(?:\.\d+)?)/i);
    if (!pay) {
        const early = raw.split(/Driver\s+MUST\s+CALL/i)[0] || raw.slice(0, 2500);
        pay = early.match(/\$\s*([\d,]+\.\d{2})\b/);
    }
    if (pay)
        L.linehaul = ocrNum(pay[1]);
    function placeFromBlock(block) {
        if (!block)
            return "";
        const m = block.match(/\bAddress:\s*([A-Za-z][A-Za-z .'\-]{1,40}?)\s+([A-Z]{2})\s+(\d{5})\b/) ||
            block.match(/\b([A-Z][A-Za-z .'\-]{1,40}?),?\s+([A-Z]{2})\s+(\d{5})\b/);
        if (!m)
            return "";
        return ocrTitle(m[1].replace(/\s+/g, " ").trim()) + ", " + m[2].toUpperCase() + " " + m[3];
    }
    const oBlock = (raw.match(/Stop\s*#?\s*1\s*Origin[\s\S]{0,700}?(?=Stop\s*#?\s*2\s*Destination|$)/i) ||
        [])[0];
    const dBlock = (raw.match(/Stop\s*#?\s*2\s*Destination[\s\S]{0,700}?(?=Freight\s*Bill|Notes|Agreed\s*Rate|$)/i) || [])[0];
    L.origin = placeFromBlock(oBlock);
    L.destination = placeFromBlock(dBlock);
    if (!L.origin || !L.destination) {
        const pair = raw.match(/([A-Za-z][A-Za-z .'\-]{1,40}?),\s*([A-Z]{2})\s+(\d{5})\s+([A-Za-z][A-Za-z .'\-]{1,40}?),\s*([A-Z]{2})\s+(\d{5})/);
        if (pair && !/JACKSONVILLE|SUTTON\s+PARK|LANDSTAR/i.test(pair[1] + " " + pair[4])) {
            if (!L.origin)
                L.origin =
                    ocrTitle(pair[1].replace(/\s+/g, " ").trim()) +
                        ", " +
                        pair[2].toUpperCase() +
                        " " +
                        pair[3];
            if (!L.destination)
                L.destination =
                    ocrTitle(pair[4].replace(/\s+/g, " ").trim()) +
                        ", " +
                        pair[5].toUpperCase() +
                        " " +
                        pair[6];
        }
    }
    if (!L.origin || !L.destination) {
        const places = [];
        let pm;
        const pre = /\b([A-Z][A-Za-z .'\-]{1,40}?),?\s+([A-Z]{2})\s+(\d{5})\b/g;
        while ((pm = pre.exec(raw))) {
            const city = pm[1].replace(/\s+/g, " ").trim();
            if (/JACKSONVILLE|SUTTON|BELFORT|LANDSTAR|MOMENTUM/i.test(city))
                continue;
            if (/^[A-Z]{2}$/.test(city))
                continue;
            places.push(ocrTitle(city) + ", " + pm[2].toUpperCase() + " " + pm[3]);
            if (places.length >= 4)
                break;
        }
        if (!L.origin && places[0])
            L.origin = places[0];
        if (!L.destination && places[1])
            L.destination = places[1];
    }
    const fscMi = raw.match(/Fuel\s*Surcharge[\s\S]{0,80}?\$?\s*([\d.]+)\s*(?:\/\s*mi(?:le)?|per\s*(?:loaded\s*)?mi(?:le)?)/i);
    if (fscMi) {
        const fn = ocrNum(fscMi[1]);
        if (fn && parseFloat(fn) > 0 && parseFloat(fn) < 5)
            L.fsc = fn;
    }
    const eq = raw.match(/Equipment:\s*([A-Za-z0-9]+)/i);
    if (eq) {
        const code = String(eq[1]).replace(/^\d+/, "").toUpperCase();
        L.equipment = OCR_EQUIP[code] || eq[1];
    }
    else if (/\bFLAT\b/.test(raw.slice(0, 1500))) {
        L.equipment = "Flatbed (F)";
    }
    const wtLabeled = raw.match(/\bWeight:\s*([\d,]+)/i);
    if (wtLabeled) {
        L.weight = ocrNum(wtLabeled[1]);
    }
    else {
        // Freight-bill line items: "... 24,000 C" (qty weight class)
        const wtClass = raw.match(/\b([\d,]{4,})\s+[A-Z]\b/);
        if (wtClass)
            L.weight = ocrNum(wtClass[1]);
    }
    fillRateConDates(raw, L);
    if (!L.origin)
        L.unreadable.push("Origin could not be read");
    if (!L.destination)
        L.unreadable.push("Destination could not be read");
    if (!L.linehaul)
        L.unreadable.push("Linehaul could not be read");
    if (!milesM)
        L.unreadable.push("Miles are not printed on this rate confirmation");
    if (!(L.linehaul || L.origin || L.destination || L.miles))
        return [];
    return [L];
}
export function ocrParseRateCons(text) {
    const raw = String(text || "");
    const t = ocrParseTrinity(raw);
    if (t.length)
        return { loads: t, kind: "Trinity rate confirmation" };
    const e = ocrParseEvans(raw);
    if (e.length)
        return { loads: e, kind: "Evans rate confirmation" };
    const l = ocrParseLandstar(raw);
    if (l.length)
        return { loads: l, kind: "Landstar rate confirmation" };
    return { loads: [], kind: "" };
}
//# sourceMappingURL=ratecon.js.map